/**
 * Helper function to get the taboola page details.
 * @param pageType - The type of the page.
 * @param url - The URL of the page.
 * @returns The taboola page details.
 */
export const getTaboolaPageDetails = (
  pageType: TaboolaPageType,
  url: string
): TaboolaPageDetails | null => {
  switch (pageType) {
    case "article":
      return { article: "auto", url };

    case "video":
      return { video: "auto", url };

    default:
      return null;
  }
};
